/* BJ Card Swap — Sephora-style swatch swap for bj-card-product snippet.
   Wired once per page via window.__bjSwatchSwapWired. Uses event delegation
   on document so it handles cards that load via AJAX (related-products). */
(function () {
  if (window.__bjSwatchSwapWired) return;
  window.__bjSwatchSwapWired = true;

  var BJ_IS_AR = document.documentElement.lang && document.documentElement.lang.toLowerCase().indexOf('ar') === 0;
  var BJ_ADD_LABEL = BJ_IS_AR ? 'إضافة إلى السلة' : 'add to cart';
  var BJ_SOLDOUT_LABEL = BJ_IS_AR ? 'نفد من المخزون' : 'Sold out';

  function decodeHTML(str) {
    if (!str) return '';
    var t = document.createElement('textarea');
    t.innerHTML = str;
    return t.value;
  }

  function findCard(el) {
    return el.closest('product-card, .bj-pc-card');
  }

  function setActiveSwatch(card, siblingId) {
    var swatches = card.querySelectorAll('[data-bj-swap]');
    swatches.forEach(function (sw) {
      var isActive = sw.getAttribute('data-sibling-id') === String(siblingId);
      sw.classList.toggle('bj-pc-card__swatch--active', isActive);
      if (isActive) {
        sw.style.borderColor = '#3D2A2A';
        sw.style.transform = 'scale(1.1)';
        sw.style.boxShadow = 'inset 0 0 0 1px #fff, 0 0 0 1.5px #3D2A2A';
      } else {
        sw.style.borderColor = '';
        sw.style.transform = '';
        sw.style.boxShadow = 'inset 0 0 0 1px rgba(255,255,255,0.6)';
      }
    });
  }

  function swapCard(card, sw) {
    var id        = sw.getAttribute('data-sibling-id');
    var url       = sw.getAttribute('data-sibling-url');
    var img1      = sw.getAttribute('data-sibling-img1');
    var img1Set   = sw.getAttribute('data-sibling-img1-set');
    var img2      = sw.getAttribute('data-sibling-img2');
    var img2Set   = sw.getAttribute('data-sibling-img2-set');
    var title     = sw.getAttribute('data-sibling-title') || '';
    var subtitle  = sw.getAttribute('data-sibling-subtitle') || '';
    var priceHTML = decodeHTML(sw.getAttribute('data-sibling-price-html') || '');
    var saveHTML  = decodeHTML(sw.getAttribute('data-sibling-save-html') || '');

    var primary = card.querySelector('.bj-pc-card__image--primary');
    if (primary && img1) {
      primary.setAttribute('src', img1);
      if (img1Set) primary.setAttribute('srcset', img1Set);
      primary.setAttribute('alt', title);
    }

    var secondary = card.querySelector('.bj-pc-card__image--secondary');
    if (secondary) {
      if (img2) {
        secondary.setAttribute('src', img2);
        if (img2Set) secondary.setAttribute('srcset', img2Set);
        secondary.setAttribute('alt', title);
        secondary.style.display = '';
      } else {
        secondary.removeAttribute('src');
        secondary.removeAttribute('srcset');
        secondary.style.display = 'none';
      }
    } else if (img2 && primary) {
      var newSec = primary.cloneNode(false);
      newSec.className = 'bj-pc-card__image bj-pc-card__image--secondary';
      newSec.setAttribute('src', img2);
      if (img2Set) newSec.setAttribute('srcset', img2Set);
      newSec.setAttribute('alt', title);
      primary.parentNode.insertBefore(newSec, primary.nextSibling);
    }

    var mediaLink = card.querySelector('.bj-pc-card__media-link');
    if (mediaLink && url) mediaLink.setAttribute('href', url);

    var titleEl = card.querySelector('.bj-pc-card__title');
    if (titleEl) titleEl.textContent = title;

    var subEl = card.querySelector('.bj-pc-card__type');
    if (subEl) subEl.textContent = subtitle;

    var priceEl = card.querySelector('.bj-pc-card__price');
    if (priceEl && priceHTML) priceEl.innerHTML = priceHTML;

    var badgesContainer = card.querySelector('.bj-pc-card__media-link') || card.querySelector('.bj-pc-card__media-wrap');
    var existingSave = card.querySelector('.bj-pc-card__save');
    if (saveHTML) {
      if (existingSave) {
        existingSave.outerHTML = saveHTML;
      } else if (badgesContainer) {
        badgesContainer.insertAdjacentHTML('beforeend', saveHTML);
      }
    } else if (existingSave) {
      existingSave.remove();
    }

    var addLink = card.querySelector('.bj-pc-card__add');
    if (addLink) {
      var available = sw.getAttribute('data-sibling-available') !== 'false';
      if (url) {
        addLink.setAttribute('href', url);
        addLink.setAttribute('data-product-url', url);
      }
      
      var labelEl = addLink.querySelector('[data-bj-add-label]') || addLink;
      
      if (available) {
        addLink.removeAttribute('disabled');
        addLink.classList.remove('bj-pc-card__add--sold-out');
        labelEl.textContent = labelEl.getAttribute('data-original') || BJ_ADD_LABEL;
      } else {
        addLink.setAttribute('disabled', '');
        addLink.classList.add('bj-pc-card__add--sold-out');
        if (!labelEl.getAttribute('data-original')) {
          labelEl.setAttribute('data-original', labelEl.textContent);
        }
        labelEl.textContent = BJ_SOLDOUT_LABEL;
      }
    }

    setActiveSwatch(card, id);
  }

  function closeAllPopups(except) {
    document.querySelectorAll('.bj-pc-card__swatches-popup').forEach(function (p) {
      if (p !== except) p.style.display = 'none';
    });
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-bj-swap]');
    if (sw) {
      e.preventDefault();
      var card = findCard(sw);
      if (card) swapCard(card, sw);
      var popup = sw.closest('.bj-pc-card__swatches-popup');
      if (popup) popup.style.display = 'none';
      return;
    }

    var more = e.target.closest('[data-bj-swatch-more]');
    if (more) {
      e.preventDefault();
      var popup = more.parentElement.querySelector('.bj-pc-card__swatches-popup');
      if (popup) {
        var isOpen = popup.style.display === 'flex';
        closeAllPopups(popup);
        popup.style.display = isOpen ? 'none' : 'flex';
      }
      return;
    }

    if (!e.target.closest('.bj-pc-card__swatches-popup')) {
      closeAllPopups(null);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllPopups(null);
  });
})();